export const getuserMessageId = "getUserid";
export const activeTab = 'activeTab';
export const activeReportNotiList = 'active_report_noti_list';
export const activeUserNotiList = 'active_user_noti_list';
export const activeUserListing = 'active_user_listing';
export const activeCategoryPop = 'active_cate_popup';
 //Notification fix
export const activeGlobalNotification = 'active_global_notification';
export const getGlobalNotification = 'get_global_notification';